import React from 'react';
import { Category } from '../../types';
import MenuItemCard from '../MenuItemCard';

interface CategoryListProps {
  categories: Category[];
}

const CategoryList: React.FC<CategoryListProps> = ({ categories }) => {
  return (
    <div className="main-content py-2">
      {categories.map((category) => (
        <div 
          key={category.id} 
          id={`category-${category.id}`} 
          className="category-section mb-5"
        >
          <h2 className="h5 fw-bolder text-uppercase mb-4 border-bottom pb-2 text-dark" style={{ letterSpacing: '1px' }}>
            {category.name}
          </h2>

          <div className={`row g-3 ${category.template === 'PIZZA' ? 'row-cols-1' : ''}`}>
            {category.items.map((item) => (
              <div key={item.id} className={category.template === 'PIZZA' ? 'col-12 border' : 'col-12 col-md-6 col-sm-6'}>
                <MenuItemCard item={item} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryList;
